//====================================================
//  Function: Category Create
//====================================================
var categoryGroup = $('.js-category-group')

function componentCategoryCreate() {
  if ($('.js-category-group').length) {
    categoryGroup = $('.js-category-group')

    addToCategoryResultCode()
    rebuildTopCategoryResult()

    $('.js-select-option').change(function () {
      var checkbox = $(this)
      // var checkboxValue = checkbox.val()
      // var checkboxCode = checkbox.closest('.js-select-item').data('code')
      $('div').removeClass('is-clicked')
      $('.code-box__item').removeClass('is-clicked')
      // clearTimeout(myTimeoutCode);
      addToCategoryResultCode()
      rebuildTopCategoryResult()
    })

    $(document).on(
      'keyup',
      '.js-select-input, .js-select-input-main, .js-select-input-another, .js-category-input',
      function () {
        addToCategoryResultCode()
        rebuildTopCategoryResult()
      },
    )

    $(document).on(
      'change',
      '.js-block-item-css .js-select-input',
      function () {
        addToCategoryResultCode()
        rebuildTopCategoryResult()
      },
    )
  }
}

function addToCategoryResultCode() {
  var arrayResultCategory = []
  var arrayResultCategoryCSS = []
  var arrayResultClassicItems = []
  var arrayResultDetailItems = []
  var arrayResultSideCategory = []
  var mainItem = false
  var anotherItemClassic = true
  var anotherItemDetail = true

  var index = $('.js-select-item')
  index.find('.js-block-item').each(function () {
    var item = $(this)
    var blockItemCSS = item.hasClass('js-block-item-css')
    if (item.data('comment') !== undefined) {
      if (item.data('comment').length) {
        if (blockItemCSS) {
          arrayResultCategoryCSS.push(
            "<div class='code__comment'>/* " +
              item.data('comment') +
              '*/</div>',
          )
        } else {
          arrayResultCategory.push(
            "<div class='code__comment'>// " + item.data('comment') + '</div>',
          )
        }
      }
    }

    item.find('.js-json-input').each(function () {
      input = $(this)
      var dataJson = input.attr('data-json')
      var dataVar = input.attr('data-var')
      if (input.val().length > 0) {
        var inputValue = input.val()
        if (dataVar === 'customProductLabelClassicTextLang') {
          arrayResultClassicItems.push(`${dataJson}:"${inputValue}"`)
        } else {
          arrayResultDetailItems.push(`${dataJson}:"${inputValue}"`)
        }
      }
    })

    if (anotherItemClassic) {
      if (arrayResultClassicItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">customProductLabelClassicTextLang</span> = <span class="js-result-value txt-green">{${arrayResultClassicItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemClassic = false
      }
    }

    if (anotherItemDetail) {
      if (arrayResultDetailItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">customProductLabelDetailTextLang</span> = <span class="js-result-value txt-green">{${arrayResultDetailItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemDetail = false
      }
    }

    item.find('.js-select-input').each(function () {
      var input = $(this)
      var inputParent = input.closest('.js-stats')
      var inputValue = input.val()
      var inputCode = inputParent.data('code')
      var inputQuotes = inputParent.data('quotes')
      var inputPX = inputParent.data('px')
      var inputType = inputParent.data('type')

      if (blockItemCSS) {
        inputValue = '' + inputValue + ''
      } else {
        if (inputQuotes == true) {
          inputValue = '"' + inputValue + '"'
        }

        if (inputPX == true) {
          inputValue = inputValue + 'px'
        }

        if (inputType == 'number') {
          inputValue = parseInt(inputValue)
        } else {
          inputValue = '"' + inputValue + '"'
        }
      }

      // var templateBoxItem = `
      // 		<div class="code-box__item">
      // 		<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
      // `
      if (input.hasClass('js-json-input')) {
      } else {
        if (blockItemCSS) {
          var templateBoxItem = `
						<div class="code-box__item">
						<strong>--<span class="js-result-type">${inputCode}</span>: <span class="js-result-value txt-green">${inputValue};</span></strong></div>
					`
          arrayResultCategoryCSS.push(templateBoxItem)
          inputParent
            .find('.js-label-value')
            .html('--' + inputCode + ' = <span> ' + inputValue + '</span>')
        } else {
          var templateBoxItem = `
						<div class="code-box__item">
						<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
					`
          arrayResultCategory.push(templateBoxItem)
          arrayResultSideCategory.push(templateBoxItem)
          inputParent
            .find('.js-label-value')
            .html('var ' + inputCode + ' = <span> ' + inputValue + '</span>')
        }
      }
    })

    item.find('.js-stats-checkbox').each(function () {
      var element = $(this)
      var checkedCheckbox = element.find('.js-select-option')
      var checkboxValue = checkedCheckbox.val()
      var clickedClass = ''
      var checkboxCode = element.data('code')
      var checkboxQuotes = element.data('quotes')

      if (checkedCheckbox.is(':checked')) {
        checkboxValue = true
      } else {
        checkboxValue = false
      }

      if (checkboxQuotes == true) {
        checkboxValue = '"' + checkboxValue + '"'
      }

      if (element.hasClass('is-clicked')) {
        clickedClass = 'is-clicked'
      }

      // if (checkboxValue === 'false' || checkboxValue === '"left"') {
      //   return false
      // }

      if (element.attr('data-type') === 'option') {
        checkboxValue = `"${element.find('select').val()}"`
      }

      var templateBoxItem = `
			<div class="code-box__item ${clickedClass}">
			<strong>var <span class="js-result-type">${checkboxCode}</span> = <span class="js-result-value txt-green">${checkboxValue};</span></strong></div>
			`
      arrayResultCategory.push(templateBoxItem)
      arrayResultSideCategory.push(templateBoxItem)
      element
        .find('.js-label-value')
        .html('var ' + checkboxCode + ' = <span> ' + checkboxValue + '</span>')
    })

    if (item.hasClass('line-break')) {
      arrayResultCategory.push('<br>')
      // arrayResultSide.push('<br>')
    }
  })

  $('.js-code-result').empty()
  $('.js-code-result--side').empty()
  $('.js-code-result--subcategory').empty()
  $('.js-code-result--css').empty()
  $('.js-code-result').append(arrayResultCategory)
  $('.js-code-result--side').append(arrayResultSideCategory)
  $('.js-code-result--css').append(arrayResultCategoryCSS)
}

var product
var productButtonType
var buttonsBlock,
  customProductLabel,
  customProductLabelRadius,
  customProductLabelTextUppercase,
  customProductLabelClassicTextSK,
  customProductLabelClassicIcon,
  customProductLabelClassicIconPosition,
  customProductLabelClassicIconType,
  customProductLabelClassicIconImage,
  customProductLabelClassicBG,
  customProductLabelDetailTextSK,
  customProductLabelDetailIcon,
  customProductLabelDetailIconPosition,
  customProductLabelDetailIconType,
  customProductLabelDetailIconImage,
  customProductLabelDetailBG

function rebuildTopCategoryResult() {
  buttonsBlock = $('.result-block')

  customProductLabel = $('#label_active').is(':checked')
  customProductLabelRadius = $('#label_radius').is(':checked')
  customProductLabelBorder = $('#label_border').is(':checked')
  customProductLabelSimple = $('#label_simple').is(':checked')

  customProductLabelIcon = $('#label_icon_set').is(':checked')
  customProductLabelIconType = $('#label_icon_type').val()
  customProductLabelPosition = $('#label_icon_position').val()
  customProductLabelSize = $('#label_icon_size').val()

  customProductLabelIconImage = $('#label_label_icon_image').val()
  customProductLabelBG = $('#label_label_bg').is(':checked')

  // CSS
  let root = document.documentElement

  root.style.setProperty(
    '--product-label-border-radius',
    $('#label_border_radius').val(),
  )

  root.style.setProperty('--product-label-BG', $('#label_bg').val())

  root.style.setProperty(
    '--product-label-title-color',
    $('#label_title_color').val(),
  )

  root.style.setProperty(
    '--product-label-border-colo',
    $('#label_border-color').val(),
  )

  if (customProductLabel) {
    $('body').addClass('custom-product-label')
    changeProductLabel()
  } else {
    $('body').removeClass('custom-product-label')
  }
}

function changeProductLabel() {
  products = $('.product')
  productsBlock = $('.products')

  if (customProductLabelRadius) {
    productsBlock.addClass('has-label-border-radius')
  }

  if (customProductLabelSimple) {
    $('body').addClass('has-simple-layout')
  }

  $('.result-item').each(function () {
    var product = $(this)
    var button

    productLabelType = 'flag-discount'
    label = product.find('.flag.flag-discount')

    removeButton(label, product)
    changeProductLabelIcon(productLabelType, label)
    changeProductLabelDesign(productLabelType, label)

    if (customProductLabelSimple) {
      changeProductLabelToSimple(product)
    }

    if (customProductLabelRadius) {
      productsBlock.addClass('has-label-border-radius')
    }

    if (customProductLabelSimple) {
      $('body').addClass('has-simple-layout')
    }
  })
}

function removeButton(label, product) {
  label.removeClass(
    'has-flags-default has-delivery-free has-code  has-border has-simple-layout has-img has-icon no-icon button-ico label-1 label-2 label-3 label-4 label-5 label-6 label-7 label-8 label-9 label-10 label-11 label-12 label-13 label-14 label-15 label-16 label-17 has-custom-bg small large top-left top-center top-right bottom-left bottom-center bottom-right',
  )
  product.removeClass('has-label-border-radius')
  $('body').removeClass('has-simple-layout')
  // $('.flags.flags-default .flag').remove()
  label.find('img').remove()
}

// Set icon for buttons in product list
function changeProductLabelIcon(type, label) {
  if (customProductLabelIconImage.length != 0) {
    label.prepend(
      `<img src="${customProductLabelIconImage}" class="btn-cart-icon">`,
    )
    label.addClass('has-img')
  }

  if (customProductLabelIcon) {
    label.addClass('has-icon')

    if (customProductLabelIconImage.length == 0) {
      label.addClass('button-ico').addClass(customProductLabelIconType)
    }
  } else {
    label.addClass('no-icon')
  }
}

// Set design for buttons in product list
function changeProductLabelDesign(type, label) {
  if (customProductLabelBG && !customProductLabelIcon) {
    label.addClass('has-custom-bg')
  }

  if (customProductLabelBorder && !customProductLabelIcon) {
    label.addClass('has-border')
  }

  if (customProductLabelPosition) {
    label.addClass(customProductLabelPosition)
  }

  if (customProductLabelSize) {
    label.addClass(customProductLabelSize)
  }
}

function changeProductLabelToSimple(type) {
  var inst = type

  // if (!inst.find('.flags.flags-default .flag-action span').length) {
  //   if (!inst.find('.flags.flags-default .flag-action').length) {
  //     var flagAction = `
  // 			<span class="flag flag-action">Akcia </span>
  // 		`
  //     inst.find('.flags.flags-default').prepend(flagAction)
  //   }

  //   inst.find('.flags.flags-default .flag-action').append('<span> -24%</span>')
  // }

  // if (customProductLabelBG) {
  //   inst.find('.flag-action').addClass('has-custom-bg')
  // }
}

// Change color picker
$('.picker-color__item').each(function () {
  var input = $(this)
  var inputColorBlock = input.find('.picker-color__input')
  var inputColor = inputColorBlock.find('input')
  var inputNumber = input.find('.js-select-input')
  var inputName = inputColor.attr('name')
  var inputValue
  inputColor.on('input', function (e) {
    inputValue = e.target.value
    inputNumber.val('#' + e.target.value.substring(1))
  })
  inputColor.change(function (e) {
    inputValue = e.target.value
    inputNumber.val('#' + e.target.value.substring(1))
    inputNumber.trigger('change')
  })

  inputNumber.keyup(function (e) {
    inputValue = e.target.value
    // inputColor.val('#' + inputValue)
    // inputColor.trigger('change')
  })
})
